import { render, staticRenderFns } from "./ValidationFilters.vue?vue&type=template&id=f4c8421a&"
import script from "./ValidationFilters.vue?vue&type=script&lang=js&"
export * from "./ValidationFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports